import {Injectable} from '@angular/core';
import {AuthHttpService} from "./auth-http.service";
import {Observable} from "rxjs";
import {optimistic} from "./common-http.service";
import {AppResponse} from "./app-response.model";
import {ProductionItem} from "../model/manufacture/item";
import {ProductionDate} from "../model/manufacture/date";

@Injectable({
  providedIn: 'root'
})
export class ManufactureApiService {

  constructor(
    private authHttp: AuthHttpService
  ) {
  }

  getAll(): Observable<Array<ProductionItem>> {
    return this.authHttp.get<Array<ProductionItem>>("/manufacture/getAll").pipe(optimistic);
  }

  getOptions(): Observable<Array<Array<String>>> {
    return this.authHttp.get<Array<Array<String>>>("/manufacture/getOptions").pipe(optimistic);
  }

  getOffDays(): Observable<Array<ProductionDate>> {
    return this.authHttp.get<Array<ProductionDate>>("/manufacture/getOffDays").pipe(optimistic);
  }

  push(items: Array<ProductionItem>) {
    return this.authHttp.post("/manufacture/push", items);
  }

  parse(days: FormData): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/manufacture/days", days, {observe: 'response'});
  }

  calculate(data: Array<string>): Observable<AppResponse<ProductionDate>> {
    return this.authHttp.post<ProductionDate>("/manufacture/calculate", data);
  }

  solve(orderItemId: number, newDate: String): Observable<AppResponse<void>> {
    return this.authHttp.post<void>("/manufacture/solve", "", {orderItemId: orderItemId, newDate: newDate});
  }
}
